import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyRadioModule as MatRadioModule } from "@angular/material/legacy-radio";
import { DialogLayoutModule, MatCoreModule } from "@obg/mat.ui.core";
import { JurisdictionPrefixModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { SelectPlayerProfileDialogContainer } from "./select-player-profile/dialog/select-player-profile-dialog.container";
import { SelectPlayerProfileComponent } from "./select-player-profile/select-player-profile.component";

const DIRECTIVES: any[] = [SelectPlayerProfileComponent, SelectPlayerProfileDialogContainer];

@NgModule({
	imports: [
		CoreUiModule,
		MatCoreModule,
		DialogLayoutModule,
		GlobalUiModule,
		CommonModule,
		CoreContentModule,
		JurisdictionPrefixModule,
		FormsModule,
		ReactiveFormsModule,
		MatRadioModule,
		MatButtonModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CasinoBlockModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, SelectPlayerProfileDialogContainer);
	}
}
